var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgressiveSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.75,
    fill: "#5555A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0746 10.6865C4.4087 10.3971 4.85952 10.1799 5.36133 10.035C5.86708 9.88903 6.43154 9.81445 7 9.81445C7.56846 9.81445 8.13292 9.88903 8.63868 10.035C9.14048 10.1799 9.5913 10.3971 9.9254 10.6865",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3374 4.83008L7.91406 7.1123",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66227 4.83008L6.08594 7.11252",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26607 6.37997C4.67082 6.37997 4.99894 6.70808 4.99894 7.11284C4.99894 7.51759 4.67082 7.8457 4.26607 7.8457C3.86132 7.8457 3.5332 7.51759 3.5332 7.11284C3.5332 6.70808 3.86132 6.37997 4.26607 6.37997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73287 6.37997C10.1376 6.37997 10.4657 6.70808 10.4657 7.11283C10.4657 7.51759 10.1376 7.8457 9.73287 7.8457C9.32812 7.8457 9 7.51759 9 7.11283C9 6.70808 9.32812 6.37997 9.73287 6.37997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgressiveSmile);
export default __webpack_public_path__ + "static/media/agressive_smile.d24c48dc640f621291a0ead49ab3ec52.svg";
export { ForwardRef as ReactComponent };